import * as React from 'react';
import { MenuItem, ListItemText } from '@material-ui/core';
import { ListItem } from '@material-ui/core';

const RESULTS_TO_SHOW = 5;
const styles = {
  container: {
    alignItems: 'flex-start',
    backgroundColor: 'transparent',
    border: 'none',
    display: 'flex',
    flexDirection: 'column' as 'column',
    margin: 0,
    minWidth: '100%',
    outline: 'none',
  },
  itemStyle: {
    height: 60,
    padding: 0,
    width: '100%',
  },
  listItemStyle: {
    borderBottom: '1px solid #E4E4E4',
    width: '100%',
  },
};

interface Props {
  filteredCities: any;
  getItemProps: any;
}

export const CityList: React.FC<Props> = ({ filteredCities, getItemProps }) => {
  return (
    <div style={styles.container}>
      {filteredCities
        .slice(0, RESULTS_TO_SHOW)
        .map((item: any, index: number) => {
          return (
            <MenuItem
              key={item}
              style={styles.itemStyle}
              {...getItemProps({ item })}
            >
              <ListItem button style={styles.listItemStyle} key={index}>
                <ListItemText
                  disableTypography
                  primary={item}
                  style={{ fontSize: 16 }}
                />
              </ListItem>
            </MenuItem>
          );
        })}
    </div>
  );
};

export default CityList;
